export const SINGLECALLCARD = 'singlecallcard';
export const LAYOUT_VIEW_NAME = 'BannerView';
